export var CardBrand;
(function (CardBrand) {
    CardBrand["UNKNOWN"] = "UNKNOWN";
    CardBrand["VISA"] = "VISA";
    CardBrand["MASTERCARD"] = "MASTERCARD";
    /** American Express */
    CardBrand["AMEX"] = "AMEX";
    CardBrand["DISCOVER"] = "DISCOVER";
    CardBrand["JCB"] = "JCB";
    /** Diners Club */
    CardBrand["DINERS"] = "DINERS";
    /** Carte Bancaire */
    CardBrand["CARTE_BLUE"] = "CARTE_BLUE";
    CardBrand["ELO"] = "ELO";
    /** deprecated, please use UNIONPAY */
    CardBrand["UNION_PAY"] = "UNION_PAY";
    CardBrand["UNIONPAY"] = "UNIONPAY";
})(CardBrand || (CardBrand = {}));
export var DirectDebitBrand;
(function (DirectDebitBrand) {
    DirectDebitBrand["UNKNOWN"] = "UNKNOWN";
    DirectDebitBrand["SEPA"] = "SEPA";
})(DirectDebitBrand || (DirectDebitBrand = {}));
export var CashType;
(function (CashType) {
    CashType["UNKNOWN"] = "UNKNOWN";
    CashType["BOLETO"] = "BOLETO";
})(CashType || (CashType = {}));
export var BankTransferType;
(function (BankTransferType) {
    BankTransferType["UNKNOWN"] = "UNKNOWN";
    BankTransferType["SOFORT"] = "SOFORT";
})(BankTransferType || (BankTransferType = {}));
export var RecurringType;
(function (RecurringType) {
    RecurringType["None"] = "None";
    RecurringType["AUTO"] = "AUTO";
    RecurringType["HYBRID"] = "HYBRID";
})(RecurringType || (RecurringType = {}));
export var AlternativePaymentMethodType;
(function (AlternativePaymentMethodType) {
    AlternativePaymentMethodType["UNKNOWN"] = "UNKNOWN";
    AlternativePaymentMethodType["PAYPAL"] = "PAYPAL";
    AlternativePaymentMethodType["EXTERNAL_CREDIT_CARD"] = "EXTERNAL_CREDIT_CARD";
    AlternativePaymentMethodType["SOFORT"] = "SOFORT";
    AlternativePaymentMethodType["SEPA_OFFLINE"] = "SEPA_OFFLINE";
    AlternativePaymentMethodType["RAZORPAY"] = "RAZORPAY";
})(AlternativePaymentMethodType || (AlternativePaymentMethodType = {}));
export var PaymentIntegration;
(function (PaymentIntegration) {
    /** e.g. for payments that don’t need special source or integration */
    PaymentIntegration["NONE"] = "NONE";
    PaymentIntegration["APPLE_PAY"] = "APPLE_PAY";
})(PaymentIntegration || (PaymentIntegration = {}));
export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["UNKNOWN"] = "UNKNOWN";
    PaymentMethodType["PAYPAL"] = "PAYPAL";
    PaymentMethodType["EXTERNAL_CREDIT_CARD"] = "EXTERNAL_CREDIT_CARD";
    PaymentMethodType["SOFORT"] = "SOFORT";
    PaymentMethodType["SEPA_OFFLINE"] = "SEPA_OFFLINE";
    PaymentMethodType["RAZORPAY"] = "RAZORPAY";
})(PaymentMethodType || (PaymentMethodType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=types.impl.js.map